export default "__VITE_ASSET__0prALLld__"